export default "__VITE_ASSET__CTLZqYrM__"